import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';

//console.log('🔍 BACKEND_URL:', BACKEND_URL); // Debug
//console.log('🔍 All ENV:', process.env); 

const API = `${BACKEND_URL}/api`;

// Get auth token from localStorage
const getAuthToken = () => localStorage.getItem('auth_token');

// Set auth token to localStorage
export const setAuthToken = (token) => localStorage.setItem('auth_token', token);

// Remove auth token
export const removeAuthToken = () => localStorage.removeItem('auth_token');

// Check if user is authenticated
export const isAuthenticated = () => !!getAuthToken();

// API client with auth header
const apiClient = axios.create({
  baseURL: API,
});

// Add auth token to requests
apiClient.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 errors
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      removeAuthToken();
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

export default apiClient;
